import React from "react";
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";

function renderInput(field, value, onChange) {
  if (field.type === "select") {
    return (
      <Input value={value || ""} onChange={(event) => onChange(event.target.value)} type="select">
        {(field.options || []).map((option) => (
          <option key={`${field.key}-${option.value}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    );
  }

  if (field.type === "textarea") {
    return (
      <Input
        rows={field.rows || 3}
        type="textarea"
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={field.placeholder}
      />
    );
  }

  return (
    <Input
      type={field.type || "text"}
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      placeholder={field.placeholder}
    />
  );
}

export default function RepeaterField({
  title,
  description,
  items,
  onChange,
  createItem,
  fields,
  addLabel,
  emptyMessage,
}) {
  const safeItems = Array.isArray(items) ? items : [];

  const updateItem = (index, key, value) => {
    onChange(
      safeItems.map((item, itemIndex) => (itemIndex === index ? { ...item, [key]: value } : item))
    );
  };

  const removeItem = (index) => {
    onChange(safeItems.filter((_, itemIndex) => itemIndex !== index));
  };

  const addItem = () => {
    onChange([...(safeItems || []), createItem()]);
  };

  return (
    <Card className="shadow-sm mb-4">
      <CardBody>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h4 className="mb-1">{title}</h4>
            {description ? <p className="text-muted mb-0">{description}</p> : null}
          </div>
          <Button color="primary" outline size="sm" type="button" onClick={addItem}>
            {addLabel || "Satır ekle"}
          </Button>
        </div>

        {!safeItems.length ? <p className="text-muted mb-0">{emptyMessage || "Henüz kayıt yok."}</p> : null}

        {safeItems.map((item, index) => (
          <Card className="border mb-3" key={item.id || `${title}-${index}`}>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <strong>{title} #{index + 1}</strong>
                <Button color="danger" outline size="sm" type="button" onClick={() => removeItem(index)}>
                  Kaldır
                </Button>
              </div>

              <Row>
                {fields.map((field) => (
                  <Col lg={field.col || 6} key={`${field.key}-${index}`}>
                    <FormGroup>
                      <Label className="form-control-label">{field.label}</Label>
                      {renderInput(field, item[field.key], (value) => updateItem(index, field.key, value))}
                    </FormGroup>
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        ))}
      </CardBody>
    </Card>
  );
}
